import styled from 'styled-components'

export default styled.div`
	display: inline-block;
	max-width: calc( 100% - 50px );
`
